import { IInventoryMasterDetail, IViewMasterDetailWithImage } from '../interfaces/';

export class ViewMasterDetailWithImage implements IViewMasterDetailWithImage {
	masterDetail: IInventoryMasterDetail;
	UnProcessedAvatar: string;
}


// WEBPACK FOOTER //
// ./src/app/models/ViewMasterDetailWithImage.ts